'use client';

import { ProfileListEditor } from './ProfileListEditor';
import { useProfileListEditorLabels } from './useProfileListEditorLabels';

export type LocationsEditorProps = {
  values: string[];
  isReadOnly: boolean;
  isSaving: boolean;
  onSave: (values: string[]) => Promise<boolean>;
};

export function LocationsEditor({
  values,
  isReadOnly,
  isSaving,
  onSave,
}: LocationsEditorProps) {
  const { title, tooltip, ...labels } = useProfileListEditorLabels('locations');

  return (
    <ProfileListEditor
      title={title}
      tooltip={tooltip}
      values={values}
      isReadOnly={isReadOnly}
      isSaving={isSaving}
      onSave={onSave}
      labels={labels}
    />
  );
}
